{
    "serviceTableMeta": {
        "name": "JobOrderService",
        "columns": [
        {
            "fieldName": "metadata.serviceName",
            "displayName": "Service",
            "dataType": "STRING"
        },
        {
            "fieldName": "metadata.vendorName",
            "displayName": "Vendor",
            "dataType": "STRING"
        },
        {
            "fieldName": "metadata.equipmentDetails",
            "displayName": "Equipments",
            "dataType": "STRING",
            "styleConfig": {
                "type": "multi-tag",
                "multiTagConfig": {
                    "labelKey": "name",
                    "backgroundColor": "var(--gray-100)",
                    "color": "var(--gray-warm-900, #1C1917)"
                }
            }

        },
        {
            "fieldName": "attributes",
            "displayName": "Attributes",
            "dataType": "STRING",
            "styleConfig": {
                "type": "multi-tag",
                "multiTagConfig": {
                    "labelKey": "displayValue"
                }
            }
        }
        ],
        "actions": [
            {
                "fieldName": "",
                "displayName": "",
                "dataType": "STRING",
                "styleConfig": {
                  "type": "action",
                  "icon": "assets/icons/pencil_icon.svg",
                  "iconStyleProperties": {
                    "background": "var(--brand-500)"
                  },
                  "styleProperties": {
                    "border-radius": "100%",
                    "background": "var(--brand-50)",
                    "padding": "8px",
                    "border": "none",
                    "box-shadow": "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
                  },
                  "actionConfig": {
                    "label": "",
                    "writeOperation": true,
                    "actionName":"edit-service"
                  }
                }
              },
              {
                "fieldName": "",
                "displayName": "",
                "dataType": "STRING",
                "styleConfig": {
                  "type": "action",
                  "icon": "assets/icons/delete_icon.svg",
                  "iconStyleProperties": {
                    "background": "var(--brand-500)"
                  },
                  "styleProperties": {
                    "border-radius": "100%",
                    "background": "var(--brand-50)",
                    "padding": "8px",
                    "border": "none",
                    "box-shadow": "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
                  },
                  "actionConfig": {
                    "label": "",
                    "writeOperation": true,
                    "actionName":"delete-service"
                  }
                }
              }
        ]
  }
}